import { SubNationalDivision } from 'src/app/classes/models/sub-national-division';
import { ModelDataType } from 'src/app/interfaces/model-data-type';

import { BaseModel } from './base-model';
import { Company } from './company';

export class CompanyOperationState extends BaseModel {
  static override columnMap = new Map<
    string,
    { property: string; type: 'column'; dataType: ModelDataType }
  >();
  static override associationMap = new Map<
    string,
    { property: string; type: 'association'; model: string }
  >();
  static override aliasedColumnMap = new Map<
    string,
    { property: string; type: 'alias' }
  >();

  static CompanyOperationStateProperties: (
    | {
        property: keyof CompanyOperationState;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof CompanyOperationState;
        type: 'alias';
      }
    | {
        property: keyof CompanyOperationState;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'id', type: 'column', dataType: 'number' },
    { property: 'CompanyId', type: 'column', dataType: 'number' },
    { property: 'SubNationalDivisionId', type: 'column', dataType: 'number' },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' },

    { property: 'Company', model: 'Company', type: 'association' }
  ];

  static {
    CompanyOperationState.CompanyOperationStateProperties.forEach(
      (propertyObject) => {
        const { property, type } = propertyObject;
        if (type === 'column') {
          CompanyOperationState.columnMap.set(property, propertyObject);
        }
        if (type === 'alias') {
          CompanyOperationState.aliasedColumnMap.set(
            property,
            propertyObject as { property: string; type: 'alias' }
          );
        }
        if (type === 'association') {
          CompanyOperationState.associationMap.set(
            property,
            propertyObject as {
              property: string;
              type: 'association';
              model: string;
            }
          );
        }
      }
    );
  }

  constructor(CompanyOperationStateObject: Partial<CompanyOperationState>) {
    super();

    CompanyOperationState.CompanyOperationStateProperties.forEach(
      (propertyObject) => {
        const { property } = propertyObject;
        const value = CompanyOperationStateObject[property];
        if (value !== undefined) {
          Object.assign(this, { [property]: value });
        }
      }
    );
  }

  id?: number;
  CompanyId?: number;
  SubNationalDivisionId?: number;
  createdAt?: Date;
  updatedAt?: Date;

  Company?: Company;
  SubNationalDivision?: SubNationalDivision;
}
